/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getPosts.defs.js'
export * as $defs from './getPosts.defs.js'
